import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import axios from 'axios';

interface ISetSiteAction {
  (site: string): void;
}

interface ILoadedAction {
  (loaded: boolean): void;
}

interface ISiteSelectProps {
  current: string;
  onSelect: ISetSiteAction;
  onLoaded?: ILoadedAction;
}

const SiteSelect = (props: ISiteSelectProps) => {
  const [loading, setLoading] = React.useState(false);
  const [loaded, setDataLoaded] = React.useState(false);
  const [sites, setSites] = React.useState([]);
  const [error, setError] = React.useState("");
//  const loadingCircle = <Container sx={{ mt: 5, width: "80px" }}><CircularProgress /></Container>
  const loadingCircle = null;
  const errorAlert = <Alert severity="error">{error}</Alert>
  const setLoaded = (v: boolean) => {
    setDataLoaded(v);
    if (props.onLoaded) props.onLoaded(v);
  }
  const getData = () => {
    setLoading(true);
    console.debug('Fetching sites...');
    axios.get("/api/dismag/sites").then(answer => {
      console.debug('Parsing sites response...');
      if (answer && answer.data.success) setSites(answer.data.payload);
      if (!answer.data.success) {
        props.onSelect("");
        setError(answer.data.payload.message);
      } else if (answer.data.payload.length === 0) {
        props.onSelect("");
        setError("No sites available for selection - check you user configuration!");
      } else if (answer.data.payload.length === 1) {
        props.onSelect(answer.data.payload[0]["contract"]);
        //props.onNext();
      }
      setLoaded(true);
      setLoading(false);
    }).catch(e => {
      console.error(e);
      setError(`${e}`);
      setLoading(false);
    });
    return loadingCircle;
  }

  if (error) return errorAlert;
  else if (!loading && !loaded) return getData(); 
  else if (!loaded) return loadingCircle;

  return <Box sx={{ display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
    {sites.map((one, idx) => {
      return <Paper key={`site-id-${idx}`}
        onClick={() => { props.onSelect(`${one["contract"]}`) }}
        sx={{ cursor: "pointer", m: 1, p: 1, maxWidth: 120, width: 120, maxHeight: 50, height: 50 }}
        elevation={props.current === one["contract"] ? 4 : 1}>
        <Typography variant="h5">{one["contract"]}</Typography>
        <Typography variant="subtitle2">{one["description"]}</Typography>
      </Paper>
    })}
  </Box>
  
}

export default SiteSelect;